import { InfoOutlined } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"

export default function LatestPriceDisplay({ timestamp }: { timestamp: string }) {
  return (
    <div className="latest-price-info">
      <div className="date-label">
        As Of
        <OPTooltip title="15-minute delayed">
          <InfoOutlined className="latest-price-info-icon" />
        </OPTooltip>
      </div>
      <span>{timestamp}</span>
    </div>
  )
}
